import { render, staticRenderFns } from "./TheHeaderAccount.vue?vue&type=template&id=3dd4b967&"
import script from "./TheHeaderAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderAccount.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports